
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const HeroSection = () => {
  const { handleSignIn, isAuthenticated, handleDashboard } = useAuth();

  return (
    <div className="relative min-h-screen overflow-hidden flex items-center">
      {/* Fixed Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-[url('/nightclub-bg.jpg')] bg-cover bg-center">
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/95 to-purple-900/20" />
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 md:py-32">
        <div className="max-w-4xl">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tight animate-in slide-in-from-left duration-700">
            Promote, Sell, and Fill Events –
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-red-400 block mt-2">
              All in One Place
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl animate-in slide-in-from-left duration-700 delay-200">
            Create events, sell tickets, and reach more partygoers with AI-driven marketing.
          </p>

          <div className="flex flex-wrap gap-4 animate-in slide-in-from-left duration-700 delay-300">
            {!isAuthenticated ? (
              <>
                <Button
                  size="lg"
                  className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-full px-8 shadow-[0_0_30px_rgba(168,85,247,0.4)] hover:shadow-[0_0_30px_rgba(168,85,247,0.6)] transition-all duration-300"
                  onClick={handleSignIn}
                >
                  Sign Up & Start Promoting
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="bg-gray-900/50 text-white border-2 border-purple-500/30 rounded-full px-8 hover:bg-gray-900 hover:border-purple-500/50 shadow-[0_0_30px_rgba(168,85,247,0.1)] hover:shadow-[0_0_30px_rgba(168,85,247,0.2)] transition-all duration-300"
                  onClick={handleSignIn}
                >
                  Log In & Manage Events
                </Button>
              </>
            ) : (
              <Button
                size="lg"
                className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-full px-8 shadow-[0_0_30px_rgba(168,85,247,0.4)] hover:shadow-[0_0_30px_rgba(168,85,247,0.6)] transition-all duration-300"
                onClick={handleDashboard}
              >
                Go to Dashboard
              </Button>
            )}
          </div>
        </div>
      </div>

      {/* Floating mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-black/90 backdrop-blur-lg md:hidden border-t border-purple-500/20 z-50">
        <Button
          className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-full shadow-[0_0_15px_rgba(168,85,247,0.4)]"
          onClick={isAuthenticated ? handleDashboard : handleSignIn}
        >
          {isAuthenticated ? "Go to Dashboard" : "Create Your First Event"}
        </Button>
      </div>
    </div>
  );
};
